import React from 'react';
import { useUi } from '../../context/UiContext';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useUi();
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-4 end-4 z-[60] space-y-2 max-w-sm">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`relative overflow-hidden p-4 rounded-lg border text-xs bg-white dark:bg-ink-elevated shadow-[var(--bc-shadow-md)] before:absolute before:inset-y-0 before:start-0 before:w-0.5 ${
            t.type === 'error'
              ? 'border-rose-500/30 before:bg-rose-500'
              : t.type === 'info'
                ? 'border-brand-500/30 before:bg-brand-500'
                : 'border-emerald-500/30 before:bg-emerald-500'
          }`}
        >
          <div className="flex justify-between gap-3">
            <p className="font-display font-bold text-ink dark:text-paper">{t.title}</p>
            <button type="button" onClick={() => removeToast(t.id)} className="text-fog hover:text-brand-500 transition-colors">
              ×
            </button>
          </div>
          <p className="text-fog mt-1 leading-relaxed">{t.message}</p>
        </div>
      ))}
    </div>
  );
};
